import { Radio, RadioGroup, Stack, Text } from "@chakra-ui/react";
import { WorklistType } from "../../types/Worklist";

interface LnQTypeStepProps {
  lnqType: WorklistType;
  setLnqType: (type: WorklistType) => void;
}

const LnQTypeStep = ({ lnqType, setLnqType }: LnQTypeStepProps) => {
  return (
    <>
      <Text color="white" fontSize="24" fontWeight="600" textAlign="center" mb="6">
        Are you activating a personal LnQ or a group LnQ?
      </Text>
      <RadioGroup
        onChange={(value) => setLnqType(value as WorklistType)}
        value={lnqType}
        colorScheme="yellow"
      >
        <Stack direction="column" spacing={4}>
          <Radio value={WorklistType.PERSONAL}>
            <Text color="white">Personal LnQ</Text>
          </Radio>
          <Radio value={WorklistType.GROUP}>
            <Text color="white">Group LnQ</Text>
          </Radio>
        </Stack>
      </RadioGroup>
    </>
  );
};

export default LnQTypeStep;
